import { get} from '/src/api/api';

export const getRankingMessage = async () => {
    // eslint-disable-next-line no-useless-catch
    try {
        const seller = await get('/ranking/getRankingMessage');
        return seller.data; 
    } catch (error) {
        throw error; 
    }
    
};
export const getunRankingMessage = async (user_name) => {
    // eslint-disable-next-line no-useless-catch
    try {
        const seller = await get('/ranking/getunRankingMessage', { user_name });
        return seller.data; 
    } catch (error) {
        throw error; 
    }
    
};

export const getUserDetailMessage = async (user_id,match_id) => {
    // eslint-disable-next-line no-useless-catch
    try {
        const seller = await get('/ranking/getUserDetailMessage', { user_id,match_id });
        return seller.data; 
    } catch (error) {
        throw error; 
    }
};

export const getUserDetailmatch = async (user_id) => {
    // eslint-disable-next-line no-useless-catch                                                                                                                                                                                                                                                                                                                                                                                                                                          
    try {
        const seller = await get('/ranking/getUserDetailmatch', { user_id });
        return seller.data; 
    } catch (error) {
        throw error; 
    }
};

export const getRankingMessageByUserName = async (user_name) => {                                                                                                                                
    // eslint-disable-next-line no-useless-catch
    try {
        const seller = await get('/ranking/getRankingMessageByUserName', { user_name });
        return seller.data; 
    } catch (error) {
        throw error; 
    }

};

export const getalluserwin = async (type,key) => {
    // eslint-disable-next-line no-useless-catch
    try {
        const seller = await get('/ranking/getalluserwin',{ type,key });

        return seller.data; 
    } catch (error) {
        throw error; 
    }
};
export const getOpponent = async (user_id,key) => {
    // eslint-disable-next-line no-useless-catch
    try {
        const seller = await get('/ranking/getOpponent',{ user_id,key });
        return seller.data; 
    } catch (error) {
        throw error; 
    }

};
export const getOpponentdetails = async (user_id,key) => {
    // eslint-disable-next-line no-useless-catch
    try {
        const seller = await get('/ranking/getOpponentdetails',{ user_id,key });
        return seller.data; 
    } catch (error) {
        throw error; 
    }

};
export const getareadata = async (area,key) => {
    // eslint-disable-next-line no-useless-catch
    try {
        const seller = await get('/ranking/getareadata',{ area,key });
        return seller.data; 
    } catch (error) {
        throw error; 
    }

};
export const getuetdata = async (key) => {
    // eslint-disable-next-line no-useless-catch
    try {
        const seller = await get('/ranking/getuetdata',{ key });
        return seller.data; 
    } catch (error) {
        throw error; 
    }
};
export const getuetdata14 = async (key) => {
    // eslint-disable-next-line no-useless-catch
    try {
        const seller = await get('/ranking/getuetdata14',{ key });
        return seller.data; 
    } catch (error) {
        throw error; 
    }
};
export const getechartsdata = async (user_id) => {
    // eslint-disable-next-line no-useless-catch
    try {
        const seller = await get('/ranking/getechartsdata',{ user_id });
        return seller.data; 
    } catch (error) {
        throw error; 
    }
};
